import { template as template_186120e31f7f4345b02ff1f6e2db3fa9 } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchMoreFiltersPillButton extends Component {
    @service
    clinicianSearch;
    get details() {
        return this.clinicianSearch.facetNames.pillDetails(this.args.facetName);
    }
    clearFilterPill = (event)=>{
        event?.stopPropagation?.();
        event?.preventDefault?.();
        let qp = this.details.clearQueryParams;
        if (Object.keys(qp).length) {
            this.clinicianSearch.query.applySearchFilter(qp);
        }
    };
    static{
        template_186120e31f7f4345b02ff1f6e2db3fa9(`
    <div
      class="pill-dropdown-filter-combo
        {{if this.details.isSelected 'pill-dropdown-filter-combo-active'}}"
      data-test-clinician-search-filter-pill={{@facetName}}
    >
      <button
        type="button"
        class="filters-pill-button filters-pill-button-filter-main"
        disabled={{@isLoading}}
      >
        <span class="pill-dropdown-filter-label">{{this.details.label}}</span>
        {{#if this.details.showCount}}
          <span class="pill-filter-count">({{this.details.count}})</span>
        {{/if}}
      </button>
      {{#if this.details.isSelected}}
        <button
          type="button"
          class="filters-pill-button filters-pill-button-filter-clear"
          aria-label={{this.details.clearAriaLabel}}
          data-test-clinician-search-filter-pill-clear={{@facetName}}
          {{on "click" this.clearFilterPill}}
        >
          {{svgJar "x-circ" aria-hidden="true"}}
        </button>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
